
export default abstract class Upgrade {
  protected credits: Record<string, number>;
  public nextCost: number;
  public abstract next: number;
  public abstract current: number;

  constructor (credits: Record<string, number>) {
    this.credits = credits
    this.nextCost = 25
  }

  reset () {
    this.nextCost = 25
  }

  canUpgrade () {
    return this.credits.current >= this.nextCost
  }

  buy () {
    this.credits.current -= this.nextCost
    this.nextCost = Math.floor(this.nextCost * 2.5)
  }

  abstract getName(): string

  serialize (): Record<string, unknown> {
    return {
      name: this.getName(),
      nextCost: this.nextCost
    }
  }
}
